import {START_STREAM, STOP_STREAM, GET_STREAMS, GET_PEER_IP, DELETE_STREAM, IMPORT_STREAMS, BACKUP_FILES, EXPORT_STREAMS, GET_LOCALCONFIG, GET_STREAM_STATS, SET_SELECTED_CONTAINER} from '../constants/actionTypes';
import objectAssign from 'object-assign';
import initialState from './initialState';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function streamListReducer(state = initialState.streamList, action) {
  let newState;

  switch (action.type) {

    case START_STREAM:
    // if(!action.containerId == ""){
    //   return initialState.streamList;
    // }
      newState = objectAssign({}, state, {containerId: action.containerId})
      return newState;

    case STOP_STREAM:
     if(!action.containerId == ""){
      return state;
    }
      newState = objectAssign({}, state, {containerId: action.containerId})
      return newState;

    case DELETE_STREAM:
    if(action.message){
      newState = objectAssign({}, state, {error: action.message});
    }
    else{
      //let s = state.containers.filter(c =>{ return c.Id  !==  action.containerId})
      newState = objectAssign({}, state, action);
    }
      return newState;

    case GET_STREAMS:
      newState = objectAssign({}, state, {containers: action.streams})
      return newState;

    case GET_PEER_IP:
      newState = objectAssign({}, state, {peerIP: action.peerIP})
      return newState;

    case GET_STREAM_STATS:
      if(action.mode == "output") {
        newState = objectAssign({}, state, {outputStats: action.stats});
      } else {
        newState = objectAssign({}, state, {inputStats: action.stats});
      }
      return newState;

    case SET_SELECTED_CONTAINER:
      newState = objectAssign({}, state, {selectedContainerId: action.containerId})
      return newState;

    case IMPORT_STREAMS:
      return state;

    case BACKUP_FILES:
      newState = objectAssign({}, state, {backupFiles: action.backupFiles})
      return newState;
    
    case EXPORT_STREAMS:
      return state;

    case GET_LOCALCONFIG:
      newState = objectAssign({}, state, {localConfig: action.localConfig})
      return newState;

    default:
      return state;
  }
}
